"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSds = setupSds;
const taskStore_1 = require("../../../taskStore");
function setupSds(corpus) {
    // these trials are run sequentially (not selected in a CAT) - every trial in a group except the first one
    const sequentialTrials = [];
    const sequentialTrialTypes = ['second_response', 'third_response', 'fourth_response'];
    const newCorpus = [];
    corpus.forEach((trial) => {
        if (trial.trialType === 'something-same-2' || sequentialTrialTypes.includes(trial.assessmentStage)) {
            sequentialTrials.push(trial);
        }
        else if (trial.trialType === 'test-dimensions') {
            trial.difficulty = NaN;
            newCorpus.push(trial);
        }
        else {
            newCorpus.push(trial);
        }
    });
    (0, taskStore_1.taskStore)('sequentialTrials', sequentialTrials);
    return newCorpus;
}
